import { ALL_BRANDS_URL_ID, EXCLUSIVES_CATEGORY_URL_ID, NEW_ARRIVALS_SUBCATEGORY_URL_ID, NEW_BRANDS_CATEGORY_URL_ID, NEW_PRODUCTS_CATEGORY_URL_ID, TOP_SELLERS_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
export var COOK_AT_HOME_URL_ID = "Cook at Home";
export var FAMILY_TIME_URL_ID = "Family Time";
export var SELF_CARE_URL_ID = "Self Care";
export var WORK_FROM_HOME_URL_ID = "Work from Home";
export var COZY_APPAREL_URL_ID = "Cozy Apparel";
export var ECO_CONSCIOUS_URL_ID = "For the Eco Conscious";
export var FREE_RETURN_URL_ID = "eligible_for_free_returns";
export var BASED_IN_EUROPE_URL_ID = "Based in Europe";
export var getCategoryDisplayName = function(categoryName, strictLocalize) {
    switch(categoryName){
        case NEW_ARRIVALS_SUBCATEGORY_URL_ID:
        case NEW_BRANDS_CATEGORY_URL_ID:
            return strictLocalize({
                id: "nK9VSo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "New Brands"
                    }
                ]
            });
        case ALL_BRANDS_URL_ID:
            return strictLocalize({
                id: "Nv74TR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "All Brands"
                    }
                ]
            });
        case NEW_PRODUCTS_CATEGORY_URL_ID:
            return strictLocalize({
                id: "Aajjcm",
                defaultMessage: [
                    {
                        type: 0,
                        value: "New Products"
                    }
                ]
            });
        case TOP_SELLERS_CATEGORY_URL_ID:
            return strictLocalize({
                id: "N2ixeG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Best Sellers"
                    }
                ]
            });
        case EXCLUSIVES_CATEGORY_URL_ID:
            return strictLocalize({
                id: "JOyC9f",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Insider Early Access"
                    }
                ]
            });
        case BASED_IN_EUROPE_URL_ID:
            return strictLocalize({
                id: "S4rv9u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Based in Europe"
                    }
                ]
            });
        default:
            return categoryName;
    }
};
var NEW_CATEGORIES = [
    NEW_BRANDS_CATEGORY_URL_ID,
    NEW_PRODUCTS_CATEGORY_URL_ID
];
export var isNewCategory = function(categoryUrlId) {
    return !categoryUrlId ? false : NEW_CATEGORIES.includes(categoryUrlId);
};
